import { Pipe, PipeTransform } from '@angular/core';
import { EnumModel } from '../../core/data/model/enum-model';

@Pipe({
  standalone : true,
  name: 'enumToArray'
})

export class EnumToArrayPipe implements PipeTransform {
  transform(value: object, excludedValues?: any[]) {
    const result: EnumModel[] = [];
    let keys = Object.keys(value);
    let values = Object.values(value);
    if (excludedValues && excludedValues.length > 0) {
      keys = keys.filter(key => {
        return !excludedValues.find(excludedValue => excludedValue == value[key]);
      });
      values = keys.map(key => value[key]);
    }
    for (let i = 0; i < keys.length; i++) {
      result.push(new EnumModel(keys[i], values[i]));
    }
    return result;
  }
}
